import { render, staticRenderFns } from "./ForgotPasswordButton.vue?vue&type=template&id=30eea77d"
import script from "./ForgotPasswordButton.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports